import _ from "lodash";
import { ArticleCategory, Location, ProductGroup, User } from "../api/schema";
import { UserLanguage } from "../lang/lang";

const max_pretty_render = 4;

export const GroupPrettyRender = (
  item: ProductGroup | null,
  depth: number | null = null
): string => {
  if (item == null) return "~";

  if (depth == null) {
    return GroupPrettyRender(item, max_pretty_render);
  } else if (depth > 0) {
    if (item.parent)
      return item.name + " < " + GroupPrettyRender(item.parent, depth - 1);
    else return item.name;
  }

  return item.name;
};

export const LocationPrettyRender = (
  item: Location | null,
  depth: number | null = null
): string => {
  if (item == null) return "~";

  if (depth == null) {
    return LocationPrettyRender(item, max_pretty_render);
  } else if (depth > 0) {
    if (item.parent)
      return item.name + " < " + LocationPrettyRender(item.parent, depth - 1);
    else return item.name;
  }

  return item.name;
};

export const ArticleCategoryPrettyRender = (item: ArticleCategory | null) =>
  _.get(UserLanguage().data.article_categories, item?.name || "", "");

export const ClerkPrettyRenderer = (c: User | null) => {
  if (c == null) return UserLanguage().data.not_set;
  if (c.displayname && c.displayname.length > 0) return c.displayname;
  return c.username;
};
